import { Component, OnInit, OnDestroy, HostListener, inject } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { Course, findCourse, whatsappLink, formatPrice, COURSES } from '../courses.data';

@Component({
  selector: 'app-course-landing',
  imports: [RouterLink],
  templateUrl: './course-landing.html',
  styleUrl: './course-landing.css',
})
export class CourseLanding implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  private titleService = inject(Title);
  private meta = inject(Meta);

  course!: Course;
  priceLabel = '';
  waLink = '';
  /** Disponible en la plantilla para formatear precios de otros cursos. */
  readonly formatPrice = formatPrice;
  otherCourses: Course[] = [];
  isScrolled = false;

  private observer?: IntersectionObserver;
  private sub?: Subscription;

  @HostListener('window:scroll')
  onScroll(): void {
    this.isScrolled = window.scrollY > 20;
  }

  ngOnInit(): void {
    this.sub = this.route.paramMap.subscribe((params) => {
      const slug = params.get('slug') ?? '';
      const course = findCourse(slug);

      if (!course) {
        this.router.navigate(['/']);
        return;
      }

      this.course = course;
      this.priceLabel = course.price != null ? formatPrice(course.price) : '';
      this.waLink = whatsappLink(course.whatsappMessage);
      this.otherCourses = COURSES.filter((c) => c.slug !== course.slug);
      this.applyMeta(course);

      window.scrollTo({ top: 0 });
      this.setupReveal();
    });
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
    this.sub?.unsubscribe();
  }

  private applyMeta(course: Course): void {
    const url = `https://grupogaeli.com/cursos/${course.slug}`;
    this.titleService.setTitle(course.metaTitle);
    this.meta.updateTag({ name: 'description', content: course.metaDescription });
    this.meta.updateTag({ property: 'og:title', content: course.metaTitle });
    this.meta.updateTag({ property: 'og:description', content: course.metaDescription });
    this.meta.updateTag({ property: 'og:url', content: url });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
  }

  private setupReveal(): void {
    this.observer?.disconnect();
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('visible');
            this.observer?.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 },
    );

    setTimeout(() => {
      document.querySelectorAll('.reveal').forEach((el) => {
        el.classList.remove('visible');
        this.observer?.observe(el);
      });
    }, 0);
  }
}
